/* IU Footer 1.1.0: native reading dialogs; no commerce or customer state. */
(() => {
  const openGuide = (dialog) => {
    if (!dialog || !dialog.matches('.iu-footer__guide-dialog') || dialog.open) return;
    dialog.querySelectorAll('.iu-choice-guide__chapter').forEach((chapter) => { chapter.open = false; });
    dialog.showModal();
    const body = dialog.querySelector('.iu-footer__guide-body');
    if (body) body.scrollTop = 0;
  };
  const init = (scope) => {
    scope.querySelectorAll('.iu-footer').forEach((footer) => {
      if (footer.dataset.iuGuidesReady || typeof HTMLDialogElement === 'undefined') return;
      footer.dataset.iuGuidesReady = 'true';
      footer.addEventListener('click', (event) => {
        const opener = event.target.closest('[data-iu-guide-open]');
        if (opener) {
          const dialog = document.getElementById(opener.dataset.iuGuideOpen);
          if (dialog && footer.contains(dialog)) openGuide(dialog);
          return;
        }
        const close = event.target.closest('[data-iu-guide-close]');
        if (close) close.closest('dialog').close();
      });
      footer.querySelectorAll('.iu-footer__guide-dialog').forEach((dialog) => {
        dialog.addEventListener('click', (event) => {
          if (event.target !== dialog) return;
          const rect = dialog.getBoundingClientRect();
          if (event.clientX < rect.left || event.clientX > rect.right ||
              event.clientY < rect.top || event.clientY > rect.bottom) dialog.close();
        });
      });
    });
    if (typeof HTMLDialogElement === 'undefined') return;
    const choiceDialog = document.querySelector('.iu-footer__guide-dialog[id^="IUFooterGuide-choice-"]');
    if (!choiceDialog) return;
    document.querySelectorAll('[data-iu-choice-guide-open]').forEach((opener) => {
      opener.setAttribute('aria-controls', choiceDialog.id);
      if (opener.dataset.iuChoiceGuideReady) return;
      opener.dataset.iuChoiceGuideReady = 'true';
      opener.addEventListener('click', () => openGuide(document.getElementById(opener.getAttribute('aria-controls'))));
    });

  };
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => init(document), { once: true });
  } else {
    init(document);
  }
  document.addEventListener('shopify:section:load', (event) => init(event.target));
})();
